import {caseValidationRules, caseValidationLabels} from '../validations/case-validations'

export default {
  methods: {
    isNeonatalCompleted(neonatal, number){
      let isComplete = true;

      neonatal.forEach( (infant, index) => {

        if (index >= number) return;

        const infantInfo = Object.keys(infant);
        infantInfo .forEach(info => {
          if(info !== 'anomalyOthers'){
            if(infant[info] === null){
              isComplete = false;
            } else if (typeof infant[info] === 'string' && infant[info].trim().length === 0) {
              isComplete = false;
            }
          }else{
            if(infant['anomalies'] && !infant['anomalyOthers']){isComplete = false;}
          }
        })
      });
      return isComplete;
    },
    compareObjects(conditions, pogscase) {
      let result = true;
      const keys = Object.keys(conditions);
      keys.forEach(key => {
        const cond = conditions[key];
        if (cond instanceof Array) {
          if(!cond.includes(pogscase[key])){
            result = false;
          }
        } else {
          if (pogscase[key] !== cond) {
            result = false;
          }
        }
      });
      return result
    },
    validateCase(caseValidationRules, pogscase) {
      const validationResult = [];
      let isRequired = true;
      const keys = Object.keys(caseValidationRules);

      keys.forEach(key => {
        if (caseValidationRules[key] instanceof Object) {
          const conditions = caseValidationRules[key]["required"];
          if (conditions)
            isRequired = this.compareObjects(conditions, pogscase);
          else
            isRequired = true;
        }
        if(isRequired && key === 'neonatal' && pogscase['infantsNumber'] > 0){
          if(!this.isNeonatalCompleted(pogscase[key], pogscase['infantsNumber'])){
            const result = {key, error: 'required'};
            validationResult.push(result)
          }
        }

        if (key === "institutionalDelivery") {
          console.log(typeof pogscase[key])
        }

        if (isRequired && typeof pogscase[key] === 'number') {
          if (caseValidationRules[key]) {
            // Validate Range
            const range = caseValidationRules[key]["range"];
            if (range) {
              let value = pogscase[key];
              if (value > range.maxValue || value < range.minValue) {
                validationResult.push({key, error:'Invalid Value'});
              }
            }

            // Validate greater
            const greater = caseValidationRules[key]["greater"];
            if (greater) {
              let value = pogscase[key];
              if (value < greater) {
                validationResult.push({key, error: 'Invalid Value'});
              }
            }
          }
        } else if (isRequired && pogscase[key] && Array.isArray(pogscase[key])) {
          if (pogscase[key].length < caseValidationRules[key]["minLength"]) {
            validationResult.push({key, error:'required'});
          }
        } else if (isRequired && pogscase[key] && typeof pogscase[key] === 'object' ) {
          if (caseValidationRules[key]) {
            let minLength = caseValidationRules[key]["minLength"];
            if (minLength) {
              if (Object.keys(pogscase[key]).length < minLength) {
                validationResult.push({key, error:'required'});
              }
            }
          }
        } else if (isRequired && typeof pogscase[key] === 'boolean') {
          if (pogscase[key] === null || pogscase[key] === undefined) {
            validationResult.push({key, error:'required'});
          }
        } else if (isRequired && !pogscase[key] && typeof pogscase[key] !== 'number') {
          const result = {key, error: 'required'};
          validationResult.push(result)
        }

        isRequired = true;
      });

      return validationResult
    },
    showCloseCaseDialog(validationResult){
      let message = 'Please fill out the following required fields correctly before closing the case : <br/>';
      validationResult.forEach(item => {
        message = message + '<br/>' + this.$options.caseValidationLabels[item.key]
      });
      this.$dialog.alert(message, {html: true, okText: 'OK'}).
      then(function(dialog) {});
    }
  },
  caseValidationRules,
  caseValidationLabels
}

